import React, { useContext, useEffect, useState } from "react";
import MainContext from "src/context/MainContext";
import TaxDocumentsDialog from "./TaxDocumentsDialog";
import { TAX_DOCUMENTS_EVENT, TaxDocumentsRequest } from "./taxDocumentsEvents";

/**
 * Mounted once at the app root. Shows the tax documents dialog when a POS or
 * membership sale asks for it (`openTaxDocuments`), even though the screen
 * that took the payment has already closed. Renders nothing until then.
 */
const FlowAccountTaxDocumentsHost = () => {
  const context = useContext(MainContext);
  const [request, setRequest] = useState<TaxDocumentsRequest | null>(null);

  useEffect(() => {
    const onOpen = (event: Event) => setRequest((event as CustomEvent<TaxDocumentsRequest>).detail);
    window.addEventListener(TAX_DOCUMENTS_EVENT, onOpen);
    return () => window.removeEventListener(TAX_DOCUMENTS_EVENT, onOpen);
  }, []);

  if (!request) return null;
  return (
    <TaxDocumentsDialog
      open
      onClose={() => setRequest(null)}
      locationId={request.locationId}
      sale={request.sale as any}
      currency={context?.SelectedLocation?.currency}
    />
  );
};

export default FlowAccountTaxDocumentsHost;
